export default function QuestionHeader({
  question,
  collapsed,
  setCollapsed,
  onDelete,
}) {
  return (
    <div className="flex justify-between items-center border border-gray-200 bg-gray-100 dark:bg-gray-800 p-4 rounded-t-lg gap-16">
      <div className="flex items-center gap-2 text-gray-900 dark:text-white font-medium text-base leading-none">
        {question.icon} {question.select}
        {collapsed && question.question && <span>({question.question})</span>}
      </div>
      <div className="flex items-center gap-2">
        <button onClick={onDelete}>
          <svg
            className="w-6 h-6 text-gray-900 dark:text-white"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
            />
          </svg>
        </button>
        <button onClick={() => setCollapsed(!collapsed)}>
          <svg
            className={`w-6 h-6 text-gray-900 dark:text-gray-300 transform transition-transform ${
              collapsed ? "rotate-180" : ""
            }`}
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m16 14-4-4-4 4"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}
